/* import __COLOCATED_TEMPLATE__ from './company-billing-general.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

import { COMPANY } from 'sh-www/models/company';

class AdminCompanyBillingGeneral extends Component {
  get tierVersionOptions() {
    return Object.values(COMPANY.TIER_VERSIONS).reduce((accum, tierVersionKey) => {
      accum.push({
        key: COMPANY.TIER_VERSION_NAMES[tierVersionKey],
        model: { id: tierVersionKey, label: COMPANY.TIER_VERSION_NAMES[tierVersionKey] },
      });

      return accum;
    }, []);
  }

  get tierOptions() {
    return Object.keys(COMPANY.TIERS).map((key) => ({
      key: COMPANY.TIER_NAMES[COMPANY.TIERS[key]],
      model: { id: COMPANY.TIERS[key], label: COMPANY.TIER_NAMES[COMPANY.TIERS[key]] },
    }));
  }

  get tierValue() {
    return COMPANY.TIER_NAMES[this.selectedTier];
  }

  get tierVersionValue() {
    const { selectedTierVersion } = this;
    return COMPANY.TIER_VERSION_NAMES[selectedTierVersion];
  }

  get selectedTier() {
    return this.args.currentValues?.tier ?? COMPANY.TIERS.FREE;
  }

  get selectedTierVersion() {
    return this.args.currentValues?.tierVersion ?? COMPANY.TIER_VERSIONS.TWO;
  }

  @action
  handleTierSelection(value) {
    return this.args.onChangeGeneral('tier', value.id);
  }

  @action
  handleTierVersionSelection(value) {
    return this.args.onChangeGeneral('tierVersion', value.id);
  }
}

export default AdminCompanyBillingGeneral;
